// TranslateWith.Wiki - A web app to translate terms using Wikipedia
// language links

// Copyright (C) 2022 Marien Raat - mail@marienraat.nl

// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as
// published by the Free Software Foundation, either version 3 of the
// License, or (at your option) any later version.

// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.

// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
import React from 'react';
import Form from 'react-bootstrap/Form'

interface Props {
  value: string;
  onChange: (val: string) => void;
  onKeyPress: any;
}

function LanguageSelector(props: Props) {
  return (
    <div className="term-input">
      <Form.Control name="term-input" id="term-input" type="text"
        value={props.value}
        onKeyPress={props.onKeyPress}
        onChange={e => props.onChange(e.target.value)}
      />
    </div>
  );
}

export default LanguageSelector;
